<template>
  <div>
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <div class="dropbox">
        <input
          type="file"
          multiple
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          class="input-file"
        />
        <span v-if="isInitial && !isSaving">
          <p class="mt20 align-text-upload">
            <v-icon class="mr-2">insert_drive_file</v-icon>Arraste ou clique
            aqui
          </p>
        </span>
        <p v-if="isSaving">Fazendo upload de {{ fileCount }} arquivo...</p>
      </div>
    </form>
    <div v-if="isSuccess">
      <h3>
        Prezado corretor, a Nomeação foi encaminhada para validação da
        seguradora, em breve retornaremos.
      </h3>
      <p>
        <a href="javascript:void(0)" @click="reset()">Reenviar o documento</a>
      </p>
      <ul class="list-unstyled">
        <li v-for="item in uploadedFiles">
          <img
            :src="item.url"
            class="img-responsive img-thumbnail"
            :alt="item.originalName"
          />
        </li>
      </ul>
    </div>
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Envio do documento falhou.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Tente novamente</a>
      </p>
      <!-- <pre>{{ uploadError }}</pre> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mt20 {
  margin-top: 20px;
}
.align-text-upload {
  text-align: left !important;
  padding-left: 35px;
}
.dropbox {
  outline: 2px dashed #c2c2c2; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  // padding: 50px;
  min-height: 85px; /* minimum height */
  position: relative;
  cursor: pointer;
  margin-left: -8px;

  .input-file {
    height: 85px;
  }
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;

  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #eee; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;

  color: #a5a5a5;
  font-size: 14px;
  font-weight: bold;
}
.list-unstyled {
  list-style: none;
}
</style>

<script lang="js">
import { upload } from "@/services/fake.file-upload.service";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "Home",
  data: () => ({
    uploadedFiles: [],
    uploadError: null,
    currentStatus: null,
    uploadFieldName: "carta_nomeacao",
    upload,
  }),
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    async saveUpload(base64File) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.$forceUpdate();
      let payload = {
        documento: base64File,
        nome: "carta_nomeacao.pdf",
        id_tomador: this.idTaker,
        content_type: "application/pdf",
      };
      try {
        await this.$store.dispatch("UPLOAD_CARTA_NOMEACAO", payload);
      } catch (e) {
        this.uploadError = (e && e.response) || "";
        this.currentStatus = STATUS_FAILED;
        this.$emit("failed");
        console.warn(e);
        return;
      }

      this.uploadedFiles = [].concat(base64File);
      this.currentStatus = STATUS_SUCCESS;
      this.$emit("complete");
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      let t = this;
      var reader = new FileReader();
      let file = fileList[0];

      reader.addEventListener(
        "load",
        function () {
          if (!reader.result) {
            this.$emit("typeFailed");
          }
          t.saveUpload(reader.result);
        },
        false
      );

      /* if(!/\.pdf$/i.test(file.name)) {
        this.$emit('typeFailed')
        return 
      } */
      if (file) {
        reader.readAsDataURL(file);
      }
      // save i
    },

    
    onChange(image) {
      if (image) {
        this.model.foto = this.$refs.pictureInput.file;
        this.changedPhoto = true;
      }
    },
  },
  props: ["idTaker"],
  mounted() {
    this.reset();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FormUploadInput.vue